import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { EcommerceGenericoService } from 'projects/mariano-max/src/app/core/ecommerce-generico/public-api';
import { AuthService } from './core/auth/auth.service';
import { AppConfigService } from './core/config/app-config.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  private obligaLogin: boolean = false;
  constructor(private serv: EcommerceGenericoService, private router: Router, private appConfigService: AppConfigService, private authService: AuthService) {

  }

  private async loadConfig() {
    try {
      const config: any = await this.appConfigService.loadConfig().toPromise();
      this.obligaLogin = config?.obligaLogin || false;
    } catch (error) {
      console.error('Error al cargar la configuración', error);
      this.obligaLogin = false;
    }
  }

  async canActivate(): Promise<boolean> {
    if (this.authService.isLogueado())
      return true;
    await this.loadConfig();

    if (this.obligaLogin) {
      this.router.navigate(['/login']);
      return false;
    }
    return true;
  }
}


